import React from 'react'
import classNames from 'classnames'

import style from './style.module.css'

export function ListGroup({
  className,
  ...props
}: React.ComponentPropsWithoutRef<'dl'>) {
  return <dl className={classNames(style.listGroup, className)} {...props} />
}

export function ListTitle({
  className,
  ...props
}: React.ComponentPropsWithoutRef<'dt'>) {
  return <dt className={classNames(style.listTitle, className)} {...props} />
}

export function ListItem({
  isCurrent,
  className,
  ...props
}: React.ComponentPropsWithoutRef<'li'> & { isCurrent: boolean }) {
  return (
    <li
      className={classNames(style.listItem, className, {
        [style.isCurrent]: isCurrent,
      })}
      {...props}
    />
  )
}

export function List({ children }: { children: React.ReactNode }) {
  return (
    <dd>
      <ul>{children}</ul>
    </dd>
  )
}
